import { createContext } from "react";

export const AuthContext = createContext(null);
export const BloggerContext = createContext(null);
export const InfluencerContext = createContext(null);
export const CreateCampaignContext = createContext(null);